import { vercel } from "@t3-oss/env-core/presets";
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const keys = () =>
	createEnv({
		extends: [vercel()],
		server: {
			ANALYZE: z.string().optional(),
			NEXT_RUNTIME: z.enum(["nodejs", "edge"]).optional(),
			PYTHON_BACKEND_URL: z.string().min(1).url(),
			PYTHON_BACKEND_API_KEY: z.string().min(1),
		},
		client: {
			NEXT_PUBLIC_APP_URL: z.string().min(1).url(),
			NEXT_PUBLIC_WEB_URL: z.string().min(1).url(),
			NEXT_PUBLIC_API_URL: z.string().min(1).url().optional(),
			NEXT_PUBLIC_DOCS_URL: z.string().min(1).url().optional(),
			NEXT_PUBLIC_LANDING_PAGE_URL: z.string().min(1).url().optional(),
		},
		runtimeEnv: {
			ANALYZE: process.env.ANALYZE,
			NEXT_RUNTIME: process.env.NEXT_RUNTIME,
			NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
			NEXT_PUBLIC_WEB_URL: process.env.NEXT_PUBLIC_WEB_URL,
			NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,
			NEXT_PUBLIC_DOCS_URL: process.env.NEXT_PUBLIC_DOCS_URL,
			NEXT_PUBLIC_LANDING_PAGE_URL: process.env.NEXT_PUBLIC_LANDING_PAGE_URL,
			PYTHON_BACKEND_URL: process.env.PYTHON_BACKEND_URL,
			PYTHON_BACKEND_API_KEY: process.env.PYTHON_BACKEND_API_KEY,
		},
	});
